//Line Type
export const LINE_TYPE_TRUCK = "TRUCK";
export const LINE_TYPE_TIRE_DETAIL = "TIRE_DETAIL";
export const LINE_TYPE_TOTAL = "TOTAL";
